import { NgModule } from '@angular/core';

import { HtmlToTextPipe } from './htmlToText.pipe';

@NgModule({
  declarations: [HtmlToTextPipe],
  exports: [HtmlToTextPipe],
})
export class PipesModule {}
